import { useQuery } from '@tanstack/react-query';

import {
  individualsService,
  FetchIndividualsRequest,
  FetchIndividualsResponse,
  useToast,
} from '@aslanpay/portal-common-lib';

interface UseFetchIndividualsOptions extends FetchIndividualsRequest {
  enabled?: boolean;
}

const useFetchIndividuals = ({
  ids,
  status,
  role,
  companyId,
  friendlyId,
  payCalendarId,
  externalPayrollId,
  email,
  isTerminationDateSet,
  onUnpaidLeave,
  allowTracking,
  allowMarketing,
  query,
  sortBy,
  sort,
  page,
  size,
  enabled,
}: UseFetchIndividualsOptions) => {
  const toast = useToast();

  return useQuery<FetchIndividualsResponse, Error>(
    [
      'fetchIndividuals',
      ids,
      status,
      role,
      companyId,
      friendlyId,
      payCalendarId,
      externalPayrollId,
      email,
      isTerminationDateSet,
      onUnpaidLeave,
      allowTracking,
      allowMarketing,
      query,
      sortBy,
      sort,
      page,
      size,
    ],
    () =>
      individualsService.fetchIndividuals({
        ids,
        status,
        role,
        companyId,
        friendlyId,
        payCalendarId,
        externalPayrollId,
        email,
        isTerminationDateSet,
        onUnpaidLeave,
        allowTracking,
        allowMarketing,
        query,
        sortBy,
        sort,
        page,
        size,
      }),
    {
      enabled,
      onError: () => {
        toast({
          position: 'top-right',
          status: 'error',
          title: 'Something went wrong',
          description: `Sorry, we failed to fetch the individuals${
            companyId?.length ? ' for this company' : ''
          }. Please try again.`,
        });
      },
    }
  );
};

export default useFetchIndividuals;
